import { forwardRef } from 'react';
// @mui
import { Avatar, Box, IconButton } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
//
import './EyheChat.css';

// ----------------------------------------------------------------------
// Toast de mensagem nova, mostrado quando a pessoa NAO esta na conversa.
// Clicar em qualquer parte abre a conversa. Some sozinho em 1 minuto.
// ----------------------------------------------------------------------

type Props = {
    nome: string;
    avatar?: string;
    resumo: string;
    onAbrir: VoidFunction;
    onFechar: VoidFunction;
};

const ToastNovaMensagem = forwardRef<HTMLDivElement, Props>(
    ({ nome, avatar, resumo, onAbrir, onFechar }, ref) => (
        <Box
            ref={ref}
            className="eyhe-toast-mensagem"
            role="button"
            tabIndex={0}
            onClick={onAbrir}
            onKeyDown={(e: any) => {
                if (e.key === 'Enter' || e.key === ' ') onAbrir();
            }}
        >
            <Avatar src={avatar} alt={nome} className="eyhe-toast-avatar">
                {nome ? nome.charAt(0).toUpperCase() : 'E'}
            </Avatar>

            <div className="eyhe-toast-texto">
                <div className="eyhe-toast-nome">{nome || 'Nova mensagem'}</div>
                <div className="eyhe-toast-resumo">{resumo}</div>
            </div>

            <IconButton
                size="small"
                className="eyhe-toast-fechar"
                aria-label="Fechar"
                onClick={(e) => {
                    e.stopPropagation();
                    onFechar();
                }}
            >
                <Iconify icon="eva:close-fill" />
            </IconButton>
        </Box>
    )
);

export default ToastNovaMensagem;
